import { Button } from "PFComponents/button";
import type { Option } from "PFTypes/propilot";
import type { OutgoingFrame } from "PFTypes/propilot";
import { useState } from "react";

import css from "./options_facet.module.scss";

type OptionReplyFrame = Extract<OutgoingFrame, { kind: "option_reply" }>;

type OptionsFacetProps = {
  options: Option[];
  onOptionSelected: (frame: OptionReplyFrame) => void;
};

export const OptionsFacet = ({ options, onOptionSelected }: OptionsFacetProps) => {
  const [selectedId, setSelectedId] = useState<string | null>(null);

  if (options.length === 0) {
    return null;
  }

  const handleClick = (option: Option) => {
    setSelectedId(option.id);

    if (option.reply !== undefined) {
      const frame: OptionReplyFrame = { kind: "option_reply", optionId: option.id, text: option.reply };
      onOptionSelected(frame);
      return;
    }

    // TODO: [SP-10137] dispatch tool calls when actionable options are implemented.
    console.log("[OptionsFacet] actionable option selected (stub):", option);
  };

  return (
    <ul className={css.optionsList} data-qa-id="OptionsFacet">
      {options.map((option) => (
        <li key={option.id}>
          <Button
            kind={selectedId === option.id ? "primary" : "secondary"}
            small
            disabled={selectedId !== null && selectedId !== option.id}
            onClick={() => handleClick(option)}
            qaId={`OptionsFacet.option.${option.id}`}
          >
            {option.label}
          </Button>
        </li>
      ))}
    </ul>
  );
};
